var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYandexPlusWhite = function SvgYandexPlusWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7245 1.18408C9.16947 1.06225 8.59286 0.998047 8.00126 0.998047C3.58228 0.998047 0 4.58033 0 8.9993C0 13.4183 3.58228 17.0006 8.00126 17.0006C12.4202 17.0006 16.0025 13.4183 16.0025 8.9993C16.0025 8.98118 16.0025 8.96307 16.0023 8.94498H10.6392L9.58209 13.9686H7.03432L8.09141 8.94498H3.04111L3.55308 6.50799H8.60421L9.7245 1.18408ZM15.6071 6.50799H11.152L12.0769 2.11243C13.7295 3.09253 14.999 4.65053 15.6071 6.50799Z",
    fill: "white"
  })));
};
export default SvgYandexPlusWhite;